module.exports = __webpack_public_path__ + "img/logo-mobile.4d495c6e.svg";